import React, { Component } from 'react';
import { Controller } from '../common/Controller';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { UsernameInput, PasswordInput } from '../common/components/TextInputs';
import { StyleSheet, css } from 'aphrodite';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppConfig } from '../AppConfig';
import async from 'async';
import { Helper } from '../common/helpers/Helper'

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingAnimation: false,
      errMsg: '',
      userName: '',
      pword: '',
    };
  }

  onSubmitLogin = () => {
    if(!this.state.userName || !this.state.pword) {
      this.setState({
        errMsg: 'Please enter email and password'
      })
      return
    }
    this.setState({
      loadingAnimation: true
    })
    const jsonBody = {
      username: this.state.userName,
      password: this.state.pword
    };

    if (AppConfig.localAuth) {
      async.parallel(
        [
          function (callback) {
            ApiHelperV2.publicApiCall(
              {
                jsonBody: jsonBody,
                method: 'POST',
                endPoint: ApiHelperV2.makeUrlPath(['locallogin'])
              }, callback)
          }
        ],
        function (err, results) {
          if (err) {
            this.setState({
              loadingAnimation: false,
              fetchState: ApiHelperV2.State.ERROR,
              errMsg: Helper.getErrorMsg(err)
            })
            return
          }
          this.setState({
            loadingAnimation: true,
          })
          const data = results[0]
          Controller.get().userMgrV2().setloggedInUserLocal(data).then((result) => {
            //console.log('setloggedInUserLocal', result)
            Controller.get().userMgrV2().navigateUserToHome();
          }).catch((error) => {
            console.log('Fetch user failure', error)
          });
        }.bind(this))
    } else {
      //TODO: firebase auth
    }
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <Paper className={css(Styles.loginPanel)}>
          <h2>Login</h2>
          <div className={css(Styles.loginMessageContainer)}>
            {this.state.errMsg.length > 0 &&
              <p className={css(Styles.loginMessage)}>{this.state.errMsg}</p>
            }
          </div>

          {this.loginView()}

        </Paper>
      </div>
    );
  }

  loginView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })} />

        <PasswordInput
          id='pword'
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter') {
              this.onSubmitLogin()
            }
          }}/>

        <div className={css(Styles.paddingTop20px)}>
          <Button fullWidth margin='normal'
            variant={this.state.loadingAnimation ? 'outlined' : 'contained'}
            color='primary'
            disabled={this.state.loadingAnimation}
            onClick={this.onSubmitLogin}
          >
            LOGIN
            {this.state.loadingAnimation && <CircularProgress color='primary' size={20} className={css(Styles.marginLeft)} />}
          </Button>
        </div>

      </div>
    );
  }
}

const Styles = StyleSheet.create({
  container: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    backgroundImage: `url(${require('../assets/images/login-bg-image.jpg')})`,
    backgroundSize: 'cover'
  },
  loginPanel: {
    textAlign: 'center',
    width: 300,
    padding: 20,
    '@media (max-width: 767px)': {
      padding: 5,
      marginLeft: 5,
      marginRight: 5,
    }
  },
  loginMessageContainer: {
    margin: 'auto'
  },
  loginMessage: {
    marginTop: 10,
    fontSize: 14,
    color: 'black'
  },
  paddingTop20px: {
    paddingTop: 20
  },
  marginLeft: {
    marginLeft: 10
  }
})



// WEBPACK FOOTER //
// ./src/screens/Login.js